import { useCallback, useEffect, useRef } from 'react';
import { useConnectModal } from '@rainbow-me/rainbowkit';

export function useCloseConnectModalController() {
  const { connectModalOpen } = useConnectModal();
  const controllerRef = useRef<AbortController>(new AbortController());

  const abort = useCallback(() => {
    const currentControllerRef = controllerRef.current;

    if (!currentControllerRef.signal.aborted) {
      currentControllerRef.abort();
    }
  }, []);

  const getController = useCallback(() => {
    abort();
    controllerRef.current = new AbortController();

    return controllerRef.current;
  }, [abort]);

  useEffect(() => {
    if (!connectModalOpen) {
      abort();
    }
  }, [connectModalOpen, abort]);

  useEffect(() => () => abort(), [abort]);

  return getController;
}
